import { Component, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ContentService } from 'src/app/content.service';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import QrScanner from 'qr-scanner';
QrScanner.WORKER_PATH = '/assets/qr-scanner-worker.min.js';

// Feilkoder fra fribillett-backend
const FB_ERRORS: { [key: number]: string } = {
  2: 'Koden finnes ikke',
  3: 'Ugyldig kodeformat',
  4: 'Koden er invalidert',
  5: 'Koden er allerede brukt'
};

@Component({
  selector: 'app-sjekk-gavekort',
  templateUrl: './sjekk-gavekort.component.html',
  styleUrls: ['./sjekk-gavekort.component.scss']
})
export class SjekkGavekortComponent implements AfterViewInit, OnDestroy {

  @ViewChild('scanVideoElm', { static: false }) private scanVideoElm;

  public resultat;
  public paused = false;
  public kode = new FormControl(
    '', {
      updateOn: 'change', /* FIXME - mdc-bug? - oppdateres på blur */
      validators: [Validators.required, Validators.minLength(8), Validators.maxLength(32)],
      asyncValidators: this.sjekkKode.bind(this)
    }
  );
  private qrScanner;

  constructor(
    private contentService: ContentService
  ) {}

  ngAfterViewInit() {
    this.qrScanner = new QrScanner(this.scanVideoElm.nativeElement, this.kodeScanned.bind(this));
    this.startScan(true);
  }

  ngOnDestroy() {
    this.qrScanner.destroy();
  }

  get erFribillett(): boolean {
    return this.kode.value?.trim().toUpperCase().startsWith('FRI') ?? false;
  }

  sjekkKode(control) {
    const verdi = control.value?.trim().toUpperCase();
    if (this.erFribillett) {
      // Fribillett-format er FRI-XXXXXXXXXX (14 tegn). Vent til koden er komplett
      // før API-kall trigges, selv om minLength(8) allerede er passert.
      if (verdi.length < 14) {
        return of(null);
      }
      return this.sjekkFribillett(verdi);
    } else {
      return this.sjekkGavekort(control);
    }
  }

  private sjekkGavekort(control) {
    return this.contentService.fetchContent(`/salg/gavekortsjekk/${control.value}`)
      .pipe(
        map(res => {
          this.resultat = res;
          if (res.res === 'OK') {
            this.pauseScan();
            return null;
          } else {
            return { kode_err: res };
          }
        })
      );
  }

  private sjekkFribillett(kode: string) {
    // TODO: Backend-endepunkt GET /salg/fribillett_verify/<kode> (uten forestilling_id) må implementeres
    // Når backend er klar, erstatt alert-stubben under med dette:
    // return this.contentService.fetchContent(`/salg/fribillett_verify/${kode}`)
    //   .pipe(
    //     map(res => {
    //       this.resultat = res;
    //       if (res.code === 1) {
    //         this.pauseScan();
    //         return null;
    //       } else {
    //         return { kode_err: res };
    //       }
    //     })
    //   );
    alert(`Sjekk av fribillett-gyldighet er ikke implementert ennå (kode: ${kode})`);
    return of(null);
  }

  getFeilmelding() {
    const err = this.kode.errors?.kode_err;
    if (!err) { return ''; }
    if (this.erFribillett) {
      return FB_ERRORS[err.code] || err.detaljer || 'Ukjent feil';
    } else {
      return err.res === 'NOTFOUND' ? 'Ugyldig gavekortkode' : err.msg;
    }
  }

  pauseScan() {
    this.paused = true;
    this.qrScanner.pause();
  }

  startScan(initial = false) {
    if (!initial) {
      delete this.resultat;
      this.kode.setValue('');
    }
    this.paused = false;
    this.qrScanner.start();
  }

  kodeScanned(kode: string) {
    if (kode) {
      this.pauseScan();
      this.kode.setValue(kode);
    }
  }
}
